import { createSlice, configureStore } from "@reduxjs/toolkit";
// interfaces
import { initialState } from "src/store/initialStates";
import {
  Notification,
  Search,
  TrackingData,
  PanelValues,
} from "src/store/interfaces";

const appSlice = createSlice({
  name: "app",
  initialState: {
    Notification: initialState.Notification as Notification,
    searchString: initialState.searchString as Search,
    trackingData: initialState.trackingData as TrackingData,
    activePanel: undefined as PanelValues,
    previousNavigation: "" as String,
    pickerModeEnabled: false as Boolean,
    optionalParam: "" as String,
    currentBalance: 0 as Number,
    mobileMode: false as Boolean
  },
  reducers: {
    setNotification(state, action) {
      state.Notification = action.payload;
    },
    setSearchString(state, action) {
      state.searchString = action.payload;
    },
    setTrackingData(state, action) {
      state.trackingData = action.payload;
    },
    setActivePanel(state, action) {
      state.activePanel = action.payload;
    },
    setPreviousNavigation(state, action) {
      state.previousNavigation = action.payload;
    },
    setPickerModeEnabled(state, action) {
      state.pickerModeEnabled = action.payload;
    },
    setOptionalParam(state, action) {
      state.optionalParam = action.payload;
    },
    setCurrentBalance(state, action) {
      state.currentBalance = action.payload;
    },
    setMobileMode(state, action) {
      state.mobileMode = action.payload;
    },
  },
});

const store = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
});
export const appActions = appSlice.actions;
export default store;
